import { IMsalContext } from "@azure/msal-react";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { UserState } from "../Model";
import { getUserProfile, getUserPicture } from '../../../Services/Graph'
import { RootState } from "..";

const initialState: UserState = {
  userProfile: null,
  userPicture: null,
  isLoaded: false,
}

export const UserSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserData.fulfilled, (state, action) => {
        state.userProfile = action.payload.userProfile;
        state.userPicture = action.payload.userPicture;
        state.isLoaded = true;
      })
  }
});
export const getUserData = createAsyncThunk(
  'user/getUserProfile',
  async (context: IMsalContext) => {
    var profile = await getUserProfile(context);
    var picture = await getUserPicture(context);

    return {
      userProfile: profile,
      userPicture: picture
    }
  }
);
export const selectUserProfile = (state: RootState) => state.user.userProfile;
export const selectUserPicture = (state: RootState) => state.user.userPicture;
export const selectIsLoaded = (state: RootState) => state.user.isLoaded;
export default UserSlice.reducer;